/**
 * Unified Authentication Hook
 * 
 * Provider-agnostic React hook that works with both Okta and MSAL
 * Returns consistent interface regardless of authentication provider
 */

// Import provider-specific hooks
import { useAuthOkta } from './useAuthOkta';
import { useAuthMsal } from './useAuthMsal';

/**
 * Unified Authentication Hook
 *
 * Reads window.REACT_APP_AUTH_PROVIDER at call time so tests can set
 * window.REACT_APP_AUTH_PROVIDER before rendering without module-load ordering issues.
 */
export const useAuth = () => {
  const provider = window.REACT_APP_AUTH_PROVIDER;
  if (provider === 'OKTA') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAuthOkta();
  } else if (provider === 'MSAL') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAuthMsal();
  }
  // Fallback — provider not configured
  console.error(`Authentication provider ${provider} not properly configured`);
  return {
    isAuthenticated: false,
    authState: { isAuthenticated: false },
    authInstance: null,
    user: null,
    authenticate: async () => {
      console.error('No authentication provider configured');
    }
  };
};

export default useAuth;
